import { useSamples } from 'new/state/samples/repository/useSamples';
import { useMemo } from 'react';
import get from 'lodash/get';
import { generateInputFormDataFromDataSet } from 'new/utils/DataSetUtil/generateInputFormDataFromDataSet';

export default function useInputSamples(id) {
  const { samples } = useSamples();

  return useMemo(() => {
    if (get(samples[id], 'flat.out')) {
      const args = { id, samples, isRecordType: false };
      const formData = generateInputFormDataFromDataSet(args);
      return formData?.input;
    }
  }, [samples, id]);
}
